<template>
  <b-form-group :id="id">
    <b-form-radio-group
      buttons
      button-variant="outline-primary"
      v-model="selected"
      @change="optionSelected"
      class="w-100 justify-content-between flex-column flex-lg-row btn-group-normal"
      :aria-label="question"
      tabindex="-1"
    >
      <b-form-radio
        v-for="(option, index) in options"
        :key="option.value"
        :value="option.value"
        role="radio"
        :class="[
          'mb-2 mb-lg-0 w-100 w-lg-auto px-2 px-lg-1 px-xl-2',
          options.length === index + 1 ? 'mr-lg-0' : 'mr-lg-1 mr-xl-2',
        ]"
        :aria-label="option.text"
      >
        <h6 class="mb-0 text-xl-center number">{{ option.number }}</h6>
        <p class="mb-0 text-xl-center text-nowrap">{{ option.text }}</p>
      </b-form-radio>
    </b-form-radio-group>
  </b-form-group>
</template>

<script>
export default {
  name: "RatingPromptBlock",
  props: {
    id: String,
    question: String,
    answers: Array,
    currentOption: Number,
  },
  data() {
    return {
      selected: this.currentOption,
    };
  },
  methods: {
    optionSelected(option) {
      this.$emit("optionSelected", { answers: option });
    },
  },
  computed: {
    options() {
      return this.answers.map((answer, index) => {
        return { value: answer.id, number: index + 1, text: answer.value.split("|")[1] };
      });
    },
  },
};
</script>

<style scoped lang="scss">
.btn-group-toggle {
  .btn-outline-primary {
    font-family: $font-family-sans-serif;
    font-weight: 400;
    border: 2px solid $color-white;
    border-radius: 4px !important;
    color: $color-dark;
    height: 58px;
    line-height: 22px;
    outline: 1px solid $color-dark;
    &:not(.active):hover {
      background: transparent;
      border: 2px solid $color-blue;
      .number {
        color: $color-blue;
      }
    }
    .number {
      font-weight: bold;
    }
  }
}
</style>
